function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleSearchConsole = function SvgGoogleSearchConsole(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 157.67 157.68"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M33.19 132.57 9.45 156.31a4.696 4.696 0 0 1-6.62 0l-1.47-1.47a4.696 4.696 0 0 1 0-6.62l23.74-23.74a4.69 4.69 0 0 1 6.63 0l1.46 1.46a4.665 4.665 0 0 1 0 6.61Z",
    style: {
      fill: "#fbbc04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.91 142.49h30.39c16.78 0 30.38-13.59 30.38-30.37V30.38C157.68 13.6 144.08 0 127.3 0h-.01C110.51 0 96.91 13.59 96.9 30.37v112.12Z",
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.62 142.49c16.78 0 30.38-13.59 30.39-30.37v-.02c0-16.78-13.59-30.38-30.37-30.38h-.02c-16.78 0-30.38 13.59-30.39 30.37v.02c0 16.78 13.59 30.38 30.37 30.39h.02Z",
    style: {
      fill: "#fbbc04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.13 142.49H88.52c-16.78 0-30.38-13.59-30.38-30.37V72.29c0-16.78 13.59-30.38 30.37-30.39h.02c16.78 0 30.38 13.59 30.39 30.37v69.44c0 .43-.35.77-.77.77Z",
    style: {
      fill: "#34a853"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.91 141.71V72.29c0-13.55-8.98-25.46-22-29.2v99.4h21.22c.43 0 .78-.34.78-.77Z",
    style: {
      fill: "#1967d2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 112.69a30.37 30.37 0 0 0-18.86-28.11v28.11c0 8.65 3.62 16.46 9.43 21.99A30.29 30.29 0 0 0 77 112.69",
    style: {
      fill: "#ea4335"
    }
  }));
};
export default SvgGoogleSearchConsole;